import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
let oldpasswordValue = '';
const dictionary = {
  en: {
    attributes: {
      newpassword:'New Password',
      confirmpassword:'Confirm Password',

    }
  }
};

Validator.localize(dictionary);

export default {
    name: 'changepassword',
    components: {},
    props: [],
    data() {
        return {
            oldpassword: '',
            newpassword: '',
            confirmpassword: '',
            loginuserid: ''
        }
    },
    computed: {

    },
    mounted() {
        var permissionEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.loginuserid = userdetail.userid;
    },
    methods: {
        changePassword() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                userid: this.loginuserid,
                oldpassword: this.oldpassword,
                newpassword: this.newpassword,
                confirmpassword: this.confirmpassword
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'changepassword',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then((response) => {
                if (response.data.code == 200) {
                    this.$alertify.success(response.data.message);
                    localStorage.removeItem('permissiondata')
                    localStorage.removeItem('userdetail')
                    localStorage.removeItem('userToken')
                    localStorage.removeItem('isLoggedIn')
                    this.$router.push('/login')
                } else if (response.data.code == 104) {
                    this.$alertify.error(response.data.message)
                }
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
        },
        resetForm(){
          this.oldpassword = '';
          this.newpassword = '',
          this.confirmpassword = '';
          this.$validator.reset();
          this.errors.clear();
          this.$router.push('/admindashboard');

        },
        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result){
              //console.log('form is valid', this.model);
              this.changePassword(event);
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        }

    }
}

Validator.extend('verifypassword', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and minimum 8 and maximum 16 characters.",
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,16}$)");
        return strongRegex.test(value);
    }
});

Validator.extend('passValue', {
  getMessage: field => "passValue",
  validate: value => {
    oldpasswordValue = value;
    return true;
  }
});

Validator.extend('verify_OldandNewPassword', {
  getMessage: field => "New Password Should Not Be Same As Old Password.",
  validate: (value) => {
        return oldpasswordValue !== value;
  }
});



// WEBPACK FOOTER //
// ./src/views/components/changepassword/changepassword.component.js